export default "https://cdn-static.gokick.com/assets/a922e5568f1cf4039f8565ae5776ec3d05b76040/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";